var base = require('settings/profile/update-profile-photo');

Vue.component('spark-update-profile-photo', {
  mixins: [base],
  methods: {
    deletePhoto(e) {
      e.preventDefault();

      axios.delete('/settings/photo')
        .then(() => {
          Bus.$emit('updateUser');
        });
    }
  }
});



// WEBPACK FOOTER //
// ./resources/assets/js/spark-components/settings/profile/update-profile-photo.js